<template>
  <div class="col-lg-12">
    <br />
    <b-row>
      <b-col class="text-left">
        <ScreensMenu />&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="showModal">
          <i class="fa fa-upload mr-2"></i> Importar Arquivo
        </b-button>
      </b-col>
    </b-row>
    <br />
    <ModalImportaArquivo />
    <b-row v-if="loadingB">
      <b-col class="text-center">
        <b-spinner size="sm" variant="success"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col v-if="!log.length" class="text-center">
        <div
          style="
            background-color: #f0f3f5;
            padding: 0.75rem;
            vertical-align: top;
            border-top: 1px solid #f0f3f5;
          "
        >
          <div role="alert" aria-live="polite">
            <div class="text-center my-2">Sem registros para listar</div>
          </div>
        </div>
        <br />
      </b-col>
      <b-col v-else>
        <CardLogImportacao :log="log" />
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left" v-if="logEnd">
        Não tem mais logs para buscar.
      </b-col>
      <b-col v-else>
        <b-button
          size="sm"
          variant="primary"
          @click="nextData()"
          :disabled="loadingNext"
        >
          {{ loadingNext ? "Carregando..." : "Carregar mais +" }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ModalImportaArquivo from "./Importacao/ModalImportaArquivo.vue";
import CardLogImportacao from "./Importacao/CardLogImportacao.vue";
import ScreensMenu from "./ScreensMenu.vue";
import barramento from "../../../barramento";
import axios from "axios";
export default {
  components: { ModalImportaArquivo, CardLogImportacao, ScreensMenu },
  data() {
    return {
      log: [],
      pagina: 0,
      loadingB: false,
      loadingNext: false,
      logEnd: false,
    };
  },
  beforeDestroy() {
    barramento.$off("log-import-loading");
  },
  created() {
    barramento.$on("log-import-loading", () => {
      this.loadingB = true;
      this.log = [];
      this.pagina = 0;
      this.getData();
    });
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    showModal() {
      barramento.$emit("modal-import-aquivo", true);
    },
    nextData() {
      this.pagina = this.pagina + 10;
      this.getData(true);
    },
    getData(load = false) {
      this.loadingNext = true;
      if (!load) this.loadingB = true;
      axios
        .get("/api/orders/import/log/" + this.pagina)
        .then((response) => {
          var data = response.data;
          data.forEach((element) => {
            this.log.push(element);
          });
          this.loadingNext = false;
          if (!load) this.loadingB = false;
          if (!data.length) this.logEnd = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Importacao.vue